import { render, staticRenderFns } from "./ColoringSchemasManager.vue?vue&type=template&id=149c2ed5&scoped=true"
import script from "./ColoringSchemasManager.vue?vue&type=script&lang=js"
export * from "./ColoringSchemasManager.vue?vue&type=script&lang=js"
import style0 from "./ColoringSchemasManager.vue?vue&type=style&index=0&id=149c2ed5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "149c2ed5",
  null
  
)

export default component.exports